import Component from '../inherited/Component'
import Helpers from '../lib/Helpers'

 export default class Product extends Component {
    constructor (elem, theme, options, ctx) {
        super(elem, theme, options, ctx)
        this._imageSliders = document.querySelectorAll('.Product__Gallery.desktop-only .Product__SlideItem');
        this._labels = this._elem.querySelectorAll('.ProductItem__Label_Variant');
        this._swatches = document.querySelectorAll('.ColorSwatch__Radio');
        this._swatchSelected = document.querySelector('.ColorSwatch__Radio:checked').value.toUpperCase();
    }

    mount () {
      const flkty = new Flickity('.Product__Slideshow');
       const progressBar = document.querySelector('.progress-bar')
      flkty.on( 'scroll', function( progress ) {
        progress = Math.max( 0, Math.min( 1, progress ) );
        progressBar.style.width = progress * 100 + '%';
      }); 

     /*  this._setZoomDiv(productImages,zoomImaged)
      this._updateMobileSlider(productImages); */
     /*  this._hideVariantImage();
      this._showBadge(); */
    }
    _setZoomDiv (productImages,zoomImaged) {
      productImages.forEach(element => {
        element.addEventListener('click', function() {
          const image = element.querySelector('img')
          zoomImaged.forEach(zoomImgEl => {
            zoomImgEl.setAttribute('data-srcset',image.getAttribute('data-srcset') )
            zoomImgEl.setAttribute('srcset',image.getAttribute('srcset') )
          })
        })
      });
    }
    
    _updateMobileSlider (imageMobiles) {
      imageMobiles.forEach((productImage,index) => {
        productImage.addEventListener('click', () => {
          $('.full-zoom-image-mobile').animate({
            scrollLeft: $('.full-zoom-image-mobile').width()*0.5,
               scrollTop: $('.full-zoom-image-mobile').height()*0.5
            }, 1000);
        })
      });
    }


    _hideVariantImage() {
      const imageSliders = [...this._imageSliders];
      const swatchValue = this._swatchSelected;
      const imagesSelected = [...imageSliders.filter(slider => slider.getAttribute('data-image-alt-color').toUpperCase() === swatchValue)];
      imageSliders.forEach(slider => {
        slider.classList.add('hide-i');
      });
      imagesSelected.forEach(function(slider, index) {
        slider.classList.remove('hide-i');
        if (imagesSelected.length === 2) {
          slider.classList('Product__SlideItem--full');
        }
        else if (imagesSelected.length === 3) {
          slider.classList.add('Product__SlideItem--none');
          if (index == 0) {
            slider.classList.add('Product__SlideItem--full');
          }
        }
      });
      document.querySelector('.Product__Gallery.desktop-only').classList.remove('hide');
      this._swatches.forEach(element => {
        element.addEventListener('change', function()  {
          const swatchValue = this.value.toUpperCase();
          const imagesSelected = [...imageSliders.filter(slider => slider.getAttribute('data-image-alt-color').toUpperCase() === swatchValue)];
          imageSliders.forEach(slider => {
            slider.classList.add('hide-i');
          });
          imagesSelected.forEach(function(slider, index) {
            slider.classList.remove('hide-i');
            if (imagesSelected.length === 2) {
              slider.classList('Product__SlideItem--full');
            }
            else if (imagesSelected.length === 3) {
              slider.classList.add('Product__SlideItem--none');
              if (index == 0) {
                slider.classList.add('Product__SlideItem--full');
              }
            }
          });
        });
      });
    }

    _showBadge() {
      const labelsToShowMobile = [...document.querySelectorAll('.Product__Gallery.tablet-only .Product__SlideItem .ProductItem__Label_Variant ')];
      if (labelsToShowMobile) {
        labelsToShowMobile.forEach(label => {
          label.classList.remove('hide');
        });
      } 
      const labelsToShow = [...document.querySelectorAll('.Product__Gallery.desktop-only .Product__SlideItem:not(.hide-i) .ProductItem__Label_Variant ')];
      const labelSelected = labelsToShow.find(label => label.getAttribute('data-variant-option') === this._swatchSelected)
      if (labelSelected) {
        labelSelected.classList.remove('hide');
      }
      this._swatches.forEach(element => {
          element.addEventListener('change', function()  {
            const swatchValue = this.value.toUpperCase();
            const labelsToShow = [...document.querySelectorAll('.Product__Gallery.desktop-only .Product__SlideItem:not(.hide-i) .ProductItem__Label_Variant ')];
            const labelSelected = labelsToShow.find(label => label.getAttribute('data-variant-option') === swatchValue)
            if (labelSelected) {
              labelSelected.classList.remove('hide');
            }
          });
        });
  }
}